<template lang="pug">
div
  #preloader(v-if="gameLaunching")
    #loader
</template>
<script>
export default {
  data() {
    return {
      feedback: {
        success: true,
        status: ""
      },
      gameLaunching:false,
      userPlatform: null,
    };
  },
  computed: {
    accountID() {
      return this.$store.getters.accountID;
    },
    sessionToken() {
      return this.$store.getters.sessionToken;
    },
    getLanguage() {
      return this.$store.getters.language || "en"
    },
  },
  created() {
    this.getMobile()
    var q = this.$route.query;
    this.launchGame(q.game, q.provider);
  },
  methods: {
    getMobile() {
      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        this.userPlatform = "mobile"
      }else{
        this.userPlatform = "web"
      }
    },
    launchGame(game, provider){
      if (this.sessionToken) {
        this.gameLaunching = true
				var vm = this
        let player_id = this.accountID
        let auth_token = this.sessionToken
        let game_code = game
        let lang_code = this.getLanguage
        this.$store
          .dispatch("user/launchOneapi", { player_id, auth_token,game_code, lang_code, provider })
          .then(response => {
            if (response.success == true) {
							setTimeout(() => {
								window.location.assign(response.data)
                vm.gameLaunching = false
							}) 
            } else {        
              vm.gameLaunching = false     
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            vm.gameLaunching = false
            if((typeof response.status) != 'object'){
              if(response.status === 'free_credit_detected'){
                this.$swal({
                  title: vm.$tc("ui.attention"),
                  text: vm.$tc("message.list.free_credit_detected"),
                  showCancelButton: true,
                  type: "info",
                  confirmButtonText: vm.$tc("ui.ok"),
                  cancelButtonText: vm.$tc("ui.deposit"),
                }).then(result => {
                  if (result.value) {
                    // vm.$router.push("/slot").catch(error =>{})
                    vm.$store.dispatch("user/setSlotSelected", 0)
                  } else if (result.dismiss) {
                    if(result.dismiss === 'cancel'){
                      vm.$router.push("deposit").catch(error =>{})
                    }
                  }
                });
              }else{
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          });
      }else{
				this.$router.push('/login').catch(err => {})
			}
    }
  }
}
</script>